/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonskindlunchmenu4Inputs */

const en_listingbuttonskindlunchmenu4 = /** @type {(inputs: Listingbuttonskindlunchmenu4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunch`)
};

const de_listingbuttonskindlunchmenu4 = /** @type {(inputs: Listingbuttonskindlunchmenu4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü`)
};

/**
* | output |
* | --- |
* | "Lunch" |
*
* @param {Listingbuttonskindlunchmenu4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonskindlunchmenu4 = /** @type {((inputs?: Listingbuttonskindlunchmenu4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonskindlunchmenu4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonskindlunchmenu4(inputs)
	return de_listingbuttonskindlunchmenu4(inputs)
});
export { listingbuttonskindlunchmenu4 as "listingButtonsKindLunchMenu" }